// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ApiPagingRequestSchema from './api-paging-request-schema';

const schema = {
  $id: '/post-excel-for-admin-request-schema',
  type: 'object',
  required: ['eventIdentifier'],
  properties: {
    id: {
      type: 'integer',
      nullable: true,
    },
    key: {
      type: 'string',
      nullable: true,
    },
    searchCriteria: {
      type: 'string',
      nullable: true,
    },
    paging: {
      ...ApiPagingRequestSchema,
    },
    selectedOrganisationId: {
      type: 'integer',
      nullable: true,
    },
    selectedEventId: {
      type: 'integer',
      nullable: true,
    },
    eventIdentifier: {
      type: 'string',
      format: 'uuid',
    },
  },
} as IJSONSchema;

export default schema;
